<template>
  <div>
    <aside id="drawer" :class="{ open : isOpen, 'viewer': isViewer }">
      <div id="handle" @click="toggleSidebar"></div>
      <div id="handletop"></div>
      <div id="drawer_content" :class="{ visible: isVisible }" v-show="isOpen">
        <slot name="sidebar-content-left"></slot>
      </div>
    </aside>
    
    <div id="content_aside" :class="{ open : isOpen, 'viewer': isViewer, 'map': isMap }">
      <slot name="main-content-right"></slot>
    </div>

  </div>  
</template>

<script>
export default {
  props: {
    initialWidthPercentageLeft: { type: Number, required: false, default: 75 },
    initialStateOpen: { type: Boolean, required: false, default: true},
    isViewer: { type: Boolean, required: false, default: false },
    isMap: { type: Boolean, required: false, default: false },
    showDrawerContentDelay: { type: Number, required: false, default: 500 }
  },
  created() {
      EventDispatcher.listen('openSidebar', () => {
          this.isOpen = true;
          this.isVisible = true;
      });
      EventDispatcher.listen('toggleSidebarMenu', (sidebarMenuState) => {
        if (this.windowWidthIsSmallerThanOrEqualTo('769px') && (this.isOpen || !this.isOpen && this.wasClosedToDisplaySidebarMenu)) {
          this.isOpen = !sidebarMenuState;
          this.isVisible = !sidebarMenuState;
          this.wasClosedToDisplaySidebarMenu = sidebarMenuState;
        };
      });
  },
  data() {
    return {
      isOpen: this.initialStateOpen,
      isVisible: this.initialStateOpen,
      wasClosedToDisplaySidebarMenu: false
    }
  },
  methods: {
    toggleSidebar: function() {
      this.isOpen = !this.isOpen;
      if (this.isVisible) {
        this.isVisible = false;
      } else {
        setTimeout(() => {
            this.isVisible = true;
        }, this.showDrawerContentDelay );
      }
    },
    windowWidthIsSmallerThanOrEqualTo: function(maxWidth) {
      return window.matchMedia('(max-width: ' + maxWidth + ')').matches
    }
  }
}
</script>

<style lang="scss">

aside#drawer {
  width:1rem;
  transition: all .5s ease-in-out;
  position:fixed;
  top:0;
  left:0;
  z-index:2000;
  background-color:#96abae;
  bottom:0;
  box-shadow: 0 0 .5rem 0 rgba(0, 0, 0, 0.2);
  
  p {
    font-size: 1rem;

    &.rights {
      font-size: 0.9rem;
    }
  }

  #handle {
    position:absolute;
    z-index:1;
    top:calc(50vh - 2.25rem);
    right:-1rem;
    width:1rem;
    height:4.5rem;
    cursor:pointer;
    box-shadow: 0 0 .5rem 0 rgba(0, 0, 0, 0.2);

    &::before {
      content:url(/img/ico-handle_1.svg);
      position:absolute;
      top:0;
      left:0;
    }
  }
  
  #handletop {
    position:absolute;
    z-index:2;
    top:0;
    right:0;
    width:1rem;
    height:100vh;
    background-color:#96abae;
  }
  
  #drawer_content {
    display:none;
  }

  &.open #drawer_content.visible {
    display:block;
  }
  
  &.open #drawer_content {
    height: 100%;
    overflow-y: scroll;
    padding: 1rem 1.25rem 1rem 1rem;
    h3 {
      font-size: 1.4rem;
      font-weight: 400;
      margin-bottom: 1.5rem;
    }
    h4 {
      color: #333;
      font-size: 0.875rem;
      border-bottom: 1px dotted #333;
      padding-bottom:.25rem;
      margin-bottom:.125rem;
    }
    label {
      font-size: 0.875rem;
      color: #333;
      vertical-align: top;
      padding-top: .2125rem;
    }
    label img {
      margin-top:-.225rem;
      width:12px;
    }
    .map-thumb {
      position: absolute;
      left:0;
      bottom:0;
      width: 100%;
      z-index:2;

      &::before {
        content:url(/img/show-details.svg);
        z-index: 2;
        position:absolute;
        top:.5rem;
        right:.5rem;
      }
    }   
  }
  
  &.open  {
      width:30%;
      transition: all .5s ease-in-out;
  }
  &.viewer.open {
    width:35%; transition: all .5s ease-in-out;
    #drawer_content {
      height: calc(100vh - 300px);
    }
  }

}

#content_aside {
  width:100%;
  margin-left:0;
  transition: all .5s ease-in-out;
  .viewer {
    padding:0;
    background-color:#000;
  }
  .viewer.open {
    width:55%;
    margin-left:40%;
  }
  &.open {
    width:70%;
    margin-left:30%;
    transition: all .5s ease-in-out;
  }
  &.viewer.open {
    width:65%;
    margin-left:35%;
    transition: all .5s ease-in-out;
  }
  &.open.map {
    width:100%;
    margin-left:0;
  }
}

@media (min-width:1200px) {
  #content_aside.open {
    width:75%;
    margin-left:25%;
  }
  aside#drawer.open {
    width:25%;
  }
}

@media (max-width:769px) {
  .map #logo-link, .locations #logo-link,
  .search #logo-link {
    left: 2rem;
  }

  .viewer-map-thumb-container {
    height: 30vh !important;
  }

  .content {
    padding-right:1rem;
    .row {
      overflow: hidden;
      overflow-x: scroll;
    }
  }

  #content_aside.open {
    width:50%;
    margin-left:50%
  }

  aside#drawer {
    &.open  {
      width:50%;
      transition: all .5s ease-in-out;
    }
    &.viewer.open {
      width:50%; transition: all .5s ease-in-out;
      
      #drawer_content {
        height: calc(100vh - 300px);
      }
    }
  }   
}

@media (max-width:576px) {
  #content_aside.open {
    width:15vw;
    margin-left:85vw;
  }

  .table {
    font-size: .8rem;
    th {
      font-size: .7rem !important;
    }
  }

  .filter-container {
    display: none !important;
  }

  figure figcaption, .card .card-header,
  aside#drawer.open #drawer_content h4 {
    font-size: .7rem !important; 
  }

  aside#drawer.open #drawer_content label div,
  aside#drawer.open #drawer_content p {
    font-size: .875rem !important;
  }

  #query {
    width:70% !important;
  }

  aside#drawer {
    &.open  {
        width:85vw;
        transition: all .5s ease-in-out;
    }
    &.viewer.open {
      width:85vw; transition: all .5s ease-in-out;
      #drawer_content {
        height: 68vh;
      }
    }
  } 
}

@media print {
  * {
    transition: none !important;
  }

  #handle, .map-thumb {
    display: none;
  }

  .content .row {
    overflow: visible !important;
    display: inline;
  }

  .col-md-6 {
    width: 50%;
    float: left;
  }

  img {
    display: block;
  }

  aside#drawer {
    position: absolute;
    padding: 50px;

    #handletop {
      display: none;
    }
  }

  aside#drawer.viewer.open {
    width: 100% !important;
    height: auto !important;
    display: inline-block !important;
    overflow: visible !important;

    #drawer_content {
      display: inline !important;
      overflow: visible !important;
      padding: 0;

      h3::before {
        content:("e-chartae — Stiftsarchiv St. Gallen");
        display: inline;
        float: right;
        padding-right: 25px;
      }

      h4 {
        border-bottom:1px solid #333 !important;
      } 
    }
  }
}

</style>